var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#D8EAF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 22V20.5H12.0625L11.7625 20.2375C11.1125 19.6625 10.6562 19.0063 10.3938 18.2688C10.1313 17.5313 10 16.7875 10 16.0375C10 14.65 10.4156 13.4156 11.2469 12.3344C12.0781 11.2531 13.1625 10.5375 14.5 10.1875V11.7625C13.6 12.0875 12.875 12.6406 12.325 13.4219C11.775 14.2031 11.5 15.075 11.5 16.0375C11.5 16.6 11.6063 17.1469 11.8188 17.6781C12.0313 18.2094 12.3625 18.7 12.8125 19.15L13 19.3375V17.5H14.5V22H10V22M17.5 21.8125V20.2375C18.4 19.9125 19.125 19.3594 19.675 18.5781C20.225 17.7969 20.5 16.925 20.5 15.9625C20.5 15.4 20.3937 14.8531 20.1812 14.3219C19.9687 13.7906 19.6375 13.3 19.1875 12.85L19 12.6625V14.5H17.5V10H22V11.5H19.9375L20.2375 11.7625C20.85 12.375 21.2969 13.0406 21.5781 13.7594C21.8594 14.4781 22 15.2125 22 15.9625C22 17.35 21.5844 18.5844 20.7531 19.6656C19.9219 20.7469 18.8375 21.4625 17.5 21.8125V21.8125",
    fill: "#004276"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessing);
export default __webpack_public_path__ + "static/media/processing.156c9edf0bf24c9dce03063ed8a532a3.svg";
export { ForwardRef as ReactComponent };